import { render, staticRenderFns } from "./workExperience.vue?vue&type=template&id=08308e7b&"
import script from "./workExperience.vue?vue&type=script&lang=js&"
export * from "./workExperience.vue?vue&type=script&lang=js&"
import style0 from "./workExperience.vue?vue&type=style&index=0&id=08308e7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports